const purchaseRequisitionStatusEnum = {
  DRAFT: 'Draft',
  COMPLETED: 'Completed',
  SUBMITTED: 'Submitted',
  CHANGES_REQUESTED: 'ChangesRequested',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
  DELETED: 'Deleted',
  SUBMIT_TO_SUPPLIER: 'SubmitToSupplier',
  SUBMITED_TO_SUPPLIER: 'SubmitedToSupplier',
}

/**
 * Status a partir dos quais a requisição não sofre mais alterações.
 * Espelha PurchaseRequisition.FinalStatuses no backend.
 */
const purchaseRequisitionFinalStatuses = [
  purchaseRequisitionStatusEnum.COMPLETED,
  purchaseRequisitionStatusEnum.CANCELED,
  purchaseRequisitionStatusEnum.DELETED,
]

const purchaseRequisitionDomains = {
  data() {
    return {
      mxPurchaseRequisitionStatusEnum: purchaseRequisitionStatusEnum,
      PurchaseRequisitionTypeEnum: {
        MANUAL: 'Manual',
      },
    }
  },
  methods: {
    /**
     * Requisições em status final não podem mais ser canceladas.
     */
    mxIsPurchaseRequisitionInFinalStatus(status) {
      return purchaseRequisitionFinalStatuses.includes(status)
    },

    /**
     * Só é possível finalizar uma requisição que já foi enviada ao fornecedor.
     */
    mxCanCompletePurchaseRequisition(status) {
      return status === purchaseRequisitionStatusEnum.SUBMITED_TO_SUPPLIER
    },

    mxIsPurchaseRequisitionReadOnly(purchaseRequisition) {
      return (
        [
          purchaseRequisitionStatusEnum.COMPLETED,
          purchaseRequisitionStatusEnum.SUBMITTED,
          purchaseRequisitionStatusEnum.SUBMIT_TO_SUPPLIER,
          purchaseRequisitionStatusEnum.SUBMITED_TO_SUPPLIER,
          purchaseRequisitionStatusEnum.CANCELED,
          purchaseRequisitionStatusEnum.REJECTED,
          purchaseRequisitionStatusEnum.DELETED,
        ].indexOf(purchaseRequisition.status) >= 0
      )
    },

    mxPurchaseRequisitionStatusOptions() {
      return [
        {
          value: purchaseRequisitionStatusEnum.DRAFT,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.DRAFT}`),
          classStyle: 'secondary',
        },
        {
          value: purchaseRequisitionStatusEnum.COMPLETED,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.COMPLETED}`),
          style: { 'background-color': '#008200' },
        },
        {
          value: purchaseRequisitionStatusEnum.SUBMITTED,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.SUBMITTED}`),
          classStyle: 'success',
        },
        {
          value: purchaseRequisitionStatusEnum.REJECTED,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.REJECTED}`),
          classStyle: 'warning',
        },
        {
          value: purchaseRequisitionStatusEnum.CHANGES_REQUESTED,
          label: this.$t(
            `PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.CHANGES_REQUESTED}`
          ),
          classStyle: 'warning',
        },
        {
          value: purchaseRequisitionStatusEnum.CANCELED,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.CANCELED}`),
          classStyle: 'danger',
        },
        {
          value: purchaseRequisitionStatusEnum.DELETED,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.DELETED}`),
          classStyle: 'danger',
        },
        {
          value: purchaseRequisitionStatusEnum.SUBMIT_TO_SUPPLIER,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.SUBMIT_TO_SUPPLIER}`),
          classStyle: 'info',
        },
        {
          value: purchaseRequisitionStatusEnum.SUBMITED_TO_SUPPLIER,
          label: this.$t(`PurchaseRequisition.Status.${purchaseRequisitionStatusEnum.SUBMITED_TO_SUPPLIER}`),
          classStyle: 'info',
        },
      ]
    },
  },
}

export default purchaseRequisitionDomains
